import {isEmpty, filter} from 'lodash'

export default function isAdmin(auth) {
  return !isEmpty(
    filter(
      auth.roles,
      (role) => role.name === 'ROLE_ADMIN' && role.active === true
    )
  );
}